import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserAuthService } from '../UserAuth.service';
import { CustomerService } from '../services/customer.service';
import { ActiveCustomer } from '../models/active-customer';

@Component({
  selector: 'app-customer-selector',
  templateUrl: './customer-selector.component.html',
  styleUrls: ['./customer-selector.component.scss'],
})
export class CustomerSelectorComponent implements OnInit {
  customers: ActiveCustomer[] = [];
  // Use a string ID rather than object reference — avoids Angular ngValue comparison issues.
  selectedCustomerId = '';
  searchTerm = '';
  isLoading = true;
  errorMessage = '';

  constructor(
    private authService: UserAuthService,
    private customerService: CustomerService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/login']);
      return;
    }

    if (this.authService.getActiveCustomer()) {
      this.router.navigate(['/']);
      return;
    }

    const objectId = this.authService.getObjectId();
    const tenantId = this.authService.CustomerTenantId;

    this.customerService.getCustomers(objectId, tenantId).subscribe({
      next: (list) => {
        this.isLoading = false;
        this.customers = list;
        this.authService.setAvailableCustomers(list);

        if (list.length === 1) {
          this.authService.setActiveCustomer(list[0]);
          this.router.navigate(['/']);
        } else if (list.length === 0) {
          this.errorMessage = 'No customers are assigned to your account. Contact your administrator.';
        } else {
          this.selectedCustomerId = list[0].CustomerId;
        }
      },
      error: () => {
        this.isLoading = false;
        this.errorMessage = 'Failed to load customers. Please try again or contact support.';
      },
    });
  }

  get useSearch(): boolean {
    return this.customers.length > 20;
  }

  get filteredCustomers(): ActiveCustomer[] {
    if (!this.searchTerm.trim()) return this.customers;
    const term = this.searchTerm.toLowerCase();
    return this.customers.filter((c) => c.CustomerName.toLowerCase().includes(term));
  }

  onContinue(): void {
    const customer = this.customers.find(c => c.CustomerId === this.selectedCustomerId);
    if (!customer) return;
    console.log('[CustomerSelector] Setting active customer:', customer);
    this.authService.setActiveCustomer(customer);
    localStorage.removeItem('lastSelectedProject');
    this.router.navigate(['/']);
  }
}
